import { ClientEvent } from '@udemy/event-tracking';
export let CourseFinderUIRegionOptions = /*#__PURE__*/function (CourseFinderUIRegionOptions) {
  CourseFinderUIRegionOptions["LIHP_BANNER"] = "lihp_banner";
  CourseFinderUIRegionOptions["LOHP_BANNER"] = "lohp_banner";
  CourseFinderUIRegionOptions["CLP_BANNER"] = "clp_banner";
  CourseFinderUIRegionOptions["SEARCH_RESULTS"] = "search_results";
  CourseFinderUIRegionOptions["CATEGORY_SELECTION_STEP"] = "category_selection_step";
  CourseFinderUIRegionOptions["SUB_CATEGORY_SELECTION_STEP"] = "sub_category_selection_step";
  CourseFinderUIRegionOptions["TOPIC_SELECTION_STEP"] = "topic_selection_step";
  CourseFinderUIRegionOptions["LIHP_TOAST"] = "lihp_toast";
  CourseFinderUIRegionOptions["LOHP_TOAST"] = "lohp_toast";
  CourseFinderUIRegionOptions["CLP_TOAST"] = "clp_toast";
  CourseFinderUIRegionOptions["TOPIC_TOAST"] = "topic_toast";
  CourseFinderUIRegionOptions["SEARCH_RESULTS_TOAST"] = "search_results_toast";
  return CourseFinderUIRegionOptions;
}({});
export class CourseFinderEntryPointPresented extends ClientEvent {
  constructor(eventData) {
    super('CourseFinderEntryPointPresented');
    Object.assign(this, eventData);
  }
}
export class CourseFinderEntryPointSelected extends ClientEvent {
  constructor(eventData) {
    super('CourseFinderEntryPointSelected');
    Object.assign(this, eventData);
  }
}
export class CourseFinderExited extends ClientEvent {
  constructor(eventData) {
    super('CourseFinderExited');
    Object.assign(this, eventData);
  }
}
export class CourseFinderEntryPointDismissed extends ClientEvent {
  constructor(eventData) {
    super('CourseFinderEntryPointDismissed');
    Object.assign(this, eventData);
  }
}
//# sourceMappingURL=guidance-entry-point-events.js.map